@if (!showViewMode) {
  <div [formGroup]="form" [ngClass]="{'inverted': invertedColor}"
    class="component-wrapper">
    <div class="label-wrapper">
      @if (label) {
        <label
          [for]="HTML_ID"
          [ngClass]="{'small': isSmallLabel}">
          <span [attr.data-cy]="labelCypressTag">{{label}}</span>
          @if (hasWarningStar) {
            <app-warning-star
              [attr.data-cy]="warningStarCypressTag"
            [type]="warningLevel"></app-warning-star>
          }
        </label>
      }
    </div>
    <div [ngClass]="{
        'invalid': !isValid,
        'focus': isFocused,
        'disabled': isDisabled,
        'alternate-background': alternateBackground}" class="input-wrapper">
      <textarea (blur)="inputBlur.emit($event)"
        (click)="inputClick.emit($event)"
        (focus)="inputFocus.emit($event)"
        (keydown)="inputKeyDown.emit($event)"
        [attr.data-cy]="textInputCypressTag"
        [formControlName]="FORM_CONTROL_NAME"
        [id]="HTML_ID"
        [maxlength]="maxLength ? maxLength : null"
        [ngStyle]="inputHeight"
        [placeholder]="placeholder"
        class="input"
      type="text"></textarea>
    </div>
    @if (showMessages) {
      @for (message of messages | anyKeyValue; track message) {
        @if (message.value.length > 0) {
          <app-warning-inline
            [warningInlineLabelsArray]="message.value"
          [warningType]="message.key"></app-warning-inline>
        }
      }
    }
  </div>
} @else {
  <div [ngClass]="{'inverted': invertedColor}" class="component-view-wrapper">
    <div class="label-wrapper">
      @if (label) {
        <label
          [ngClass]="{'small': isSmallLabel}">
          <span class="input-text-area-value" [attr.data-cy]="labelCypressTag">{{label}}</span>
        </label>
      }
    </div>
    <div [attr.data-cy]="inputWrapperCypressTag"
      [ngStyle]="inputHeight"
      class="input-wrapper view-mode">
      <span class="input-text-area-value" [attr.data-cy]="inputValueCypressTag">{{initialValue}}</span>
    </div>
  </div>
}

